import { FC } from 'react';
import { useEnhancedTranslation } from '@app/hooks';
import './order-tab-component.scss';
import { NewButton } from '@app/components/NewButton/NewButton';
import { Link } from 'react-router-dom';

type TProps = {
  id: string;
  titleNumber: string;
  date: string;
  status: 'notPayment' | 'onWay' | 'completed' | 'cancel' | 'awaiting';
  price: string;
  cards: {
    id: string;
    image: string;
    price: string;
    nominal: string;
    count?: number;
  }[];
  onCancel: () => void;
  onPayment: () => void;
};

const OrderTabComponent: FC<TProps> = ({ id, titleNumber, date, status, price, cards, onCancel, onPayment }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.orders.item' });
  return (
    <div className="order-tab-component">
      <div className="order-tab-component__title-wrap">
        <div className="order-tab-component__title-block">
          <div className="order-tab-component__title-row">
            <div className="order-tab-component__item-title">
              {t('title')} {titleNumber}
            </div>
            <div className="order-tab-component__item-date">
              {t('dateWord')} {date}
            </div>
            <div className={`order-tab-component__item-status order-tab-component__item-status--${status}`}>
              {t(`statuses.${status}`)}
            </div>
          </div>
          <Link
            to={`/lk/orders/${id}`}
            className="order-tab-component__item-more order-tab-component__item-more--desctop"
          >
            {t('more')}
          </Link>
        </div>
        <div className="order-tab-component__title-price-wrap">
          <Link
            to={`/lk/orders/${id}`}
            className="order-tab-component__item-more order-tab-component__item-more--mobile"
          >
            {t('more')}
          </Link>
          <div className="order-tab-component__item-price">{price}</div>
        </div>
      </div>
      <div className="order-tab-component__cards-wrap">
        {cards?.map((item) => (
          <div className="order-tab-component__card" key={item.id}>
            <div className="order-tab-component__card-image">
              <img src={item.image} alt="" />
            </div>
            <div className="order-tab-component__card-info">
              <div className="order-tab-component__card-price">{item.price}</div>
              {item.count && (
                <div className="order-tab-component__card-count">
                  {item.nominal} x {item.count}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {status === 'notPayment' && (
        <div className="order-tab-component__bottom-wrap">
          <NewButton
            size="medium"
            variant="outline-cancel"
            onClick={onCancel}
            addClass="order-tab-component__btn order-tab-component__btn--cancel"
          >
            {t('cancelBtn')}
          </NewButton>
          <NewButton
            size="medium"
            onClick={onPayment}
            addClass="order-tab-component__btn order-tab-component__btn--pay"
          >
            {t('paymentBtn')}
          </NewButton>
        </div>
      )}
    </div>
  );
};

export default OrderTabComponent;
